<template>
  <div class="top-scoring-list">
    <NotificationBanner
      v-if="list?.bowlers.length === 0"
      :message="$t('top-scoring-lists.empty-list')"
    />

    <div v-else class="top-scoring-list-body">
      <small></small>
      <small>{{ $t('top-scoring-lists.heading-name') }}</small>
      <small>{{ $t('top-scoring-lists.heading-club') }}</small>
      <small>{{ $t('top-scoring-lists.heading-klass') }}</small>
      <small>{{ $t('top-scoring-lists.heading-age-group') }}</small>
      <small>{{ $t('top-scoring-lists.heading-gender') }}</small>
      <small>{{ $t('top-scoring-lists.heading-current-average') }}</small>
      <small>{{ $t('top-scoring-lists.heading-season-games') }}</small>
      <small>{{ $t('top-scoring-lists.heading-cut-score-games') }}</small>
      <small>{{ $t('top-scoring-lists.heading-previous-average') }}</small>

      <template v-for="(entry, index) in list?.bowlers" :key="index">
        <small>{{ 1 + index }}</small>
        <small>{{ entry.bowler.lastName }}, {{ entry.bowler.firstName }}</small>
        <small>{{ entry.bowler.activeClub }}</small>
        <small>{{ entry.bowler.klass }}</small>
        <small>{{ entry.bowler.ageGroupName }}</small>
        <small>{{ formatGender(entry.bowler.gender) }}</small>
        <small>
          {{ formatFloat(entry.averages.current, 2) }}
        </small>
        <small>{{ formatFloat(entry.gameCounts.currentSeason, 0) }}</small>
        <small>{{ formatFloat(entry.gameCounts.cutScore, 0) }}</small>
        <small>{{ formatFloat(entry.averages.previous, 2) }}</small>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { PropType } from 'vue'

import NotificationBanner from '@/components/common/NotificationBanner.vue'
import { TopScoringList } from '@/store/modules/top-scoring-lists.types'
import { formatFloat, formatGender } from '@/utils/format'

defineProps({
  list: {
    type: Object as PropType<TopScoringList | undefined>,
    default: null,
  },
})
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/globals';

.top-scoring-list {
  overflow-x: auto;

  .top-scoring-list-body {
    display: grid;
    grid-template-columns: repeat(10, auto);

    small {
      padding: 0.25em 0.75em;
      text-align: center;
      white-space: nowrap;
    }

    small:nth-child(-n + 10) {
      background-color: $color-accent;
      color: $color-text-inverted;
      font-weight: bold;
    }

    small:nth-child(10n + 1) {
      text-align: right;
    }

    small:nth-child(10n + 2),
    small:nth-child(10n + 3) {
      text-align: left;
    }
  }
}
</style>
